import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { fetchWorkspaceUnreadCount } from '../lib/centralNotifications';

/**
 * Shell-compatible unread count hook — Central-backed.
 *
 * Returns the workspace-wide unread notification count from Central.
 * Legacy's own /alerts endpoint is no longer consulted; Central is the
 * sole source of truth for alerts and notifications.
 */
export function useUnreadCount(): {
  count: number;
  isLoading: boolean;
  isError: boolean;
} {
  const workspaceId = useSelector(
    (state: RootState) => state.boot.context?.currentWorkspace?.id ?? null,
  );

  const { data, isLoading, isError } = useQuery({
    queryKey: ['workspaceUnreadCount', workspaceId],
    queryFn: () => fetchWorkspaceUnreadCount(workspaceId!),
    enabled: !!workspaceId,
    refetchInterval: 60000,
    staleTime: 30000,
    retry: 1,
  });

  return {
    count: data?.unreadCount ?? 0,
    isLoading,
    isError,
  };
}
